import React from 'react';
import PropTypes from 'prop-types';
import { either, startsWith } from 'ramda';
import { HtmlLink, RouterLink } from './targetLink.styles';

const isUrlExternal = either(startsWith('http'), startsWith('mailto'));

export const TargetLink = ({ to, children, className, openExternalInNewTab, openInternalInNewTab }) => {
  const isExternal = isUrlExternal(to);
  const LinkElement = isExternal ? HtmlLink : RouterLink;
  const linkTarget = openInternalInNewTab || (isExternal && openExternalInNewTab) ? '_blank' : undefined;
  const linkUrlProp = isExternal ? { href: to } : { to };

  return (
    <LinkElement className={className} {...linkUrlProp} target={linkTarget}>
      {children}
    </LinkElement>
  );
};

TargetLink.propTypes = {
  openExternalInNewTab: PropTypes.bool,
  openInternalInNewTab: PropTypes.bool,
  className: PropTypes.string,
  to: PropTypes.string,
  children: PropTypes.any,
};

TargetLink.defaultProps = {
  openExternalInNewTab: true,
  openInternalInNewTab: false,
};
